import type { SVGProps } from 'react';

interface EmptySkuIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function EmptySkuIcon({ className, ...props }: EmptySkuIconProps) {
  return (
    <svg
      width="24"
      height="16"
      viewBox="12 16 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M24.001 16C25.1055 16 26.0009 16.8954 26.001 18C26.001 18.4222 25.8688 18.813 25.6455 19.1357C29.8157 19.8261 33.1126 23.0952 33.8457 27.251H36.001V28.751H33.9941C33.9962 28.8337 34.001 28.9168 34.001 29V30C34.0008 31.1044 33.1054 31.9998 32.001 32H16C14.8955 32 14.0001 31.1045 14 30V29C14 28.9168 14.0038 28.8337 14.0059 28.751H12V27.251H14.1553C14.8884 23.0952 18.1851 19.826 22.3555 19.1357C22.1324 18.8131 22.001 18.422 22.001 18C22.001 16.8954 22.8964 16 24.001 16ZM15.5059 28.751C15.5035 28.8336 15.5 28.9168 15.5 29V30C15.5001 30.276 15.7239 30.5 16 30.5H32.001C32.2769 30.4998 32.5008 30.2759 32.501 30V29C32.501 28.9168 32.4965 28.8336 32.4941 28.751H15.5059ZM24 20.499C19.905 20.4992 16.487 23.3953 15.6807 27.251H32.3203C31.514 23.3952 28.0952 20.499 24 20.499ZM24.001 17.5C23.7249 17.5 23.501 17.7239 23.501 18C23.501 18.2761 23.7249 18.5 24.001 18.5C24.2771 18.5 24.501 18.2762 24.501 18C24.5009 17.7239 24.2771 17.5 24.001 17.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
